import React from 'react';
import video from '../../assets/video.mp4';
import useStyles from './Styles'

function Header() {
    const classes=useStyles();

    return (
        <div>
            <video src={video} loop muted autoPlay className={classes.video}>
                 <span className={classes.header}>

            </span>
            </video>

        </div>
    );
}

export default Header;
